import useEmblaCarousel from 'embla-carousel-react'
import { useMemo } from 'react'

export const EmblaSwiper = ({
  slides
}) => {

  const [emblaRef, emblaApi] = useEmblaCarousel()

  const _segs = useMemo(() => {
    if (slides && slides.length > 0) {
      return slides.map(seg => {
        return <div className={`embla__slide ${slides.length === 1 ? 'solo' : ''}`}>{seg.content}</div>
      })
    }
    return []
  }, [slides])

  return (
    <div className="embla">
      <div className="embla__viewport" ref={emblaRef}>
        <div className="embla__container">
          {_segs}
        </div>
      </div>
    </div>
  )
}